import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SmyFullPopup.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(__unplugin_components_0, {
    attrs: {
      "popup-style": {
        background: '#f8f8f8',
        zIndex: '99'
      }
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('group-title', [_vm._v(i18n.tc("584"))]), _c('group', [_c('x-textarea', {
    attrs: {
      "max": 200,
      "placeholder": i18n.tc("583")
    },
    model: {
      value: _vm.form.message,
      callback: function ($$v) {
        _vm.$set(_vm.form, "message", $$v);
      },
      expression: "form.message"
    }
  })], 1), _c('group', [_c(__unplugin_components_1, {
    attrs: {
      "hidden-border": ""
    },
    model: {
      value: _vm.form.imgList,
      callback: function ($$v) {
        _vm.$set(_vm.form, "imgList", $$v);
      },
      expression: "form.imgList"
    }
  })], 1), _c('group'), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "primary",
      "show-loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("334"))])], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };